import { Panel } from '@xyflow/react'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { Plus, StickyNote, Tag } from 'lucide-react'

interface CanvasActionsProps {
  onAddNode: () => void
  onAddStickyNote?: () => void
  onEditTags?: () => void
}

export default function CanvasActions({ onAddNode, onAddStickyNote, onEditTags }: CanvasActionsProps) {
  return (
    <Panel position="top-right">
      <TooltipProvider>
        <div className="flex flex-col items-center gap-2">
          <Tooltip>
            <TooltipTrigger asChild>
              <Button aria-label="Add node" size="icon" variant="default" onClick={onAddNode} className="shadow">
                <Plus className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="left" align="center">
              Add node
            </TooltipContent>
          </Tooltip>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                aria-label="Add sticky note"
                size="icon"
                variant="outline"
                onClick={onAddStickyNote}
                className="shadow"
              >
                <StickyNote className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="left" align="center">
              Add sticky note
            </TooltipContent>
          </Tooltip>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                aria-label="Manage workflow tags"
                size="icon"
                variant="outline"
                onClick={onEditTags}
                className="shadow"
              >
                <Tag className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="left" align="center">
              Workflow tags
            </TooltipContent>
          </Tooltip>
        </div>
      </TooltipProvider>
    </Panel>
  )
}
